import moment from "moment";
const getOption = (
  data1: Array<number>,
  type: string,
  element: string
): any => {
  console.log(element)
  const x: string[] = [];
  const y: number[] = [];
  let stationName: string = "";
  data1.forEach((e: any, index: number) => {
    if (index % 2 === 0) {
      e.labelPostion = "bottom";
    } else {
      e.labelPostion = "top";
    }
    x.push(moment(e.datetime, "YYYYMMDDHHmmss").format("DD日HH") + "时");
    y.push(Math.round(e[element] * 10) / 10);
    stationName = e.stationName;
  });

  const fontSize = 14;
  let leftPostion = 15;
  let topPostion = 40;
  let yAxisShow = false;
  let splitLine = false;
  let showAllSymbol = false;
  let titleShow = false;
  let xInterval = 5;
  let xLabelFormat = undefined;
  let bottomPostion = 35;
  let dataZoomDisAble = false;
  let dataZoom = 100;
  let tooltipShow = false;
  if (type === "full") {
    leftPostion = 35;
    topPostion = 40;
    titleShow = true;
    yAxisShow = true;
    splitLine = true;
    showAllSymbol = true;
    xInterval = 1;
    dataZoomDisAble = true;
    dataZoom = 100;
    xLabelFormat = function (value: string) {
      let pattern = new RegExp("[\u4E00-\u9FA5]+");
      const values = value.split("");
      let result = "";
      values.forEach((charValue) => {
        result += charValue;
        if (pattern.test(charValue)) {
          result += "\n";
        }
      });
      return result;
    };
    bottomPostion = 80;
    tooltipShow = true;
  }

  return {
    title: {
      show: titleShow,
      textStyle: {
        color: "#2D96F7",
      },
      text: stationName + "-过去24小时温度(°C)",
    },
    tooltip: {
      trigger: "axis",
      show: tooltipShow,
    },
    animation: true,
    grid: {
      left: leftPostion,
      right: 10,
      top: topPostion,
      bottom: 25,
    },
    roam: false,

    xAxis: {
      type: "category",
      data: x,
      boundaryGap: true,
      axisLabel: {
        fontFamily: "PingFangSC-Regular",
        interval: xInterval,
        formatter: xLabelFormat,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#2D96F7",
        },
      },
      axisTick: {
        show: false,
      },
    },
    dataZoom: [
      {
        type: "inside",
        disabled: !dataZoomDisAble,
        start: 0,
        end: dataZoom,
      },
    ],
    yAxis: {
      show: yAxisShow,
      type: "value",
      min: (value: any) => Math.round(value.min - 1),
      max: (value: any) => Math.round(value.max + 1),
      // splitNumber: 1,
      splitLine: { show: splitLine },
      interval: 1,
      axisLine: {
        show: true,
        lineStyle: {
          color: "#2D96F7",
        },
      },
    },
    series: {
      data: y.map((item, index) => {
        return {
          value: item,
          label: {
            // 设置显示label
            show: true,
            // 设置label的位置
            position: index % 2 === 0 ? "top" : "bottom",
            color: "#2893F6",
            fontSize,
            distance: 12,
          },
        };
      }),
      silent: true,
      markPoint: {
        symbol: "pin",
        data: [
          {
            type: "max",
            name: "Max",
            itemStyle: {
              color: "rgba(250, 173, 20, 1)",
            },
          },
          {
            type: "min",
            name: "Min",
            itemStyle: {
              color: "RGBA(53, 154, 248, 0.7)",
            },
          },
        ],
      },
      // markLine: {
      //   data: [{ type: "average", name: "Avg" }],
      // },
      symbol: "cicle",
      showAllSymbol: showAllSymbol,
      smooth: true,
      // label: {
      //   show: true,
      //   color: "#ED8E25",

      //   fontSize,
      // },
      lineStyle: {
        width: 2,
        color: "RGBA(83, 169, 250, 1)",
      },
      itemStyle: {
        color: "RGBA(83, 169, 250, 1)",
      },
      type: "line",
      yAxisIndex: 0,
    },
  };
};
export default getOption;
